import {
    Component,
    OnInit,
    EventEmitter,
    Output,
    ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';

declare var $: any;

export interface TreeView {
    id: number;
    parent: string;
    text: string;
    value: Array<number>;
}

/**
 * Generate array of numbers
 */
function numberGenerator(from: number, to: number): number[] {
    const numberArray = new Array<number>();
    for (let i = from; i <= to; i++) {
        numberArray.push(i);
    }
    return numberArray;
}

/**
 * Task types in tree view
 */
export const TASK_TYPES: Array<TreeView> = [
    {
        id: 1,
        parent: '#',
        text: 'Gestiones administrativas',
        value: [10201, 10113, 10131, 13101],
    },
    {
        id: 11,
        parent: '1',
        text: 'Solicitar fecha de alta',
        value: [10201],
    },
    {
        id: 12,
        parent: '1',
        text: 'Confirmar datos',
        value: [10113],
    },
    {
        id: 13,
        parent: '1',
        text: 'Pasar a baja',
        value: [10131],
    },
    {
        id: 14,
        parent: '1',
        text: 'Contacto administrativo',
        value: [13101],
    },
    {
        id: 2,
        parent: '#',
        text: 'Citaciones',
        value: [13001, 13002, 13011, 14001, 14011,15001],
    },
    {
        id: 21,
        parent: '2',
        text: 'Burofax',
        value: [13001],
    },
    {
        id: 22,
        parent: '2',
        text: 'Pedir cita (Burofax)',
        value: [13002],
    },
    {
        id: 23,
        parent: '2',
        text: 'Acuse de recibo (Burofax)',
        value: [13011],
    },
    {
        id: 24,
        parent: '2',
        text: 'SMS',
        value: [14001],
    },
    {
        id: 25,
        parent: '2',
        text: 'Acuse de recibo (SMS)',
        value: [14011],
    },
    {
        id: 26,
        parent: '2',
        text: 'Videoconsulta',
        value: [15001],
    },
    {
        id: 27,
        parent: '2',
        text: 'Cambio Citacion (SMS)',
        value: [14002],
    },
    {
        id: 28,
        parent: '2',
        text: 'Cambio Citacion (Video consulta)',
        value: [15002],
    },
    {
        id: 3,
        parent: '#',
        text: 'Visitas',
        value: [
            30000, 30001, 30002, 30003, 30004, 30005, 30006, 30007, 30008,
            30009, 30010, 30011, 30012, 30013, 30014, 30015, 30016, 30017,
            30018, 30019, 30020, 30021, 30022, 30023, 30024, 30025, 30026,
            30027, 30028, 30029, 30030, 30031, 30032, 30033, 30034, 30035,
            30036, 30037, 30038, 30039, 30040, 30041, 30042, 30043, 30044,
            30045, 30046, 30047, 30048, 30049, 30050, 30051, 30052, 30053,
            30054, 30055, 30056, 30057, 30058, 30059, 30060, 30061, 30062,
            30063, 30064, 30065, 30066, 30067, 30068, 30069, 30070, 30071,
            30072, 30073, 30074, 30075, 30076, 30077, 30078, 30079, 30080,
            30081, 30082, 30083, 30084, 30085, 30086, 30087, 30088, 30089,
            30090, 30091, 30092, 30093, 30094, 30095, 30096, 30097, 30098,
            30099, 30100, 30101, 30102, 30103, 30104, 30105, 30106, 30107,
            30108, 30109, 30110, 30111, 30112, 30113, 30114, 30115, 30116,
            30117, 30118, 30119, 30130, 30131, 30132, 30133, 30134, 30135,
            30136, 30137, 30138, 30139, 30140, 30141, 30142, 30143, 30144,
            30145, 30146, 30147, 30148, 30149, 30150, 30151, 30152, 30153,
            30154, 30155, 30156, 30157, 30158, 30159, 30160, 30161, 30162,
            30163, 30164, 30165, 30166, 30167, 30168, 30169, 30170, 30171,
            30172, 30173, 30174, 30175, 30176, 30177, 30178, 30179, 30180,
            30181, 30182, 30183, 30184, 30185, 30186, 30187, 30188, 30189,
            30190, 30191, 30192, 30193, 30194, 30195, 30196, 30197, 30198,
            30199, 30200, 30201, 30202, 30203, 30204, 30205, 30206, 30207,
            30208, 30209, 30210, 30211, 30212, 30213, 30214, 30215, 30216,
            30217, 30218, 30219, 30220, 30221, 30222, 30223, 30224, 30225,
            30226, 30227, 30228, 30229, 30230, 30231, 30232, 30233, 30234,
            30235, 30236, 30237, 30238, 30239, 30240, 30241, 30242, 30243,
            30244, 30245, 30246, 30247, 30248, 30249, 30250, 30251, 30252,
            30253, 30254, 30255, 30256, 30257, 30258, 30259, 30260, 30261,
            30262, 30263, 30264, 30265, 30266, 30267, 30268, 30269, 30270,
            30271, 30272, 30273, 30274, 30275, 30276, 30277, 30278, 30279,
            30280, 30281, 30282, 30283, 30284, 30285, 30286, 30287, 30288,
            30289, 30290, 30291, 30292, 30293, 30294, 30295, 30296, 30297,
            30298, 30299,
        ],
    },
    {
        id: 4,
        parent: '#',
        text: 'Contactos:',
        value: [
            31000, 31001, 31002, 31003, 31004, 31005, 31006, 31007, 31008,
            31009, 31010, 31011, 31012, 31013, 31014, 31015, 31016, 31017,
            31018, 31019, 31020, 31021, 31022, 31023, 31024, 31025, 31026,
            31027, 31028, 31029, 31030, 31031, 31032, 31033, 31034, 31035,
            31036, 31037, 31038, 31039, 31040, 31041, 31042, 31043, 31044,
            31045, 31046, 31047, 31048, 31049, 31050, 31051, 31052, 31053,
            31054, 31055, 31056, 31057, 31058, 31059, 31060, 31061, 31062,
            31063, 31064, 31065, 31066, 31067, 31068, 31069, 31070, 31071,
            31072, 31073, 31074, 31075, 31076, 31077, 31078, 31079, 31080,
            31081, 31082, 31083, 31084, 31085, 31086, 31087, 31088, 31089,
            31090, 31091, 31092, 31093, 31094, 31095, 31096, 31097, 31098,
            31099, 31100, 31101, 31102, 31103, 31104, 31105, 31106, 31107,
            31108, 31109, 31110, 31111, 31112, 31113, 31114, 31115, 31116,
            31117, 31118, 31119, 31130, 31131, 31132, 31133, 31134, 31135,
            31136, 31137, 31138, 31139, 31140, 31141, 31142, 31143, 31144,
            31145, 31146, 31147, 31148, 31149, 31150, 31151, 31152, 31153,
            31154, 31155, 31156, 31157, 31158, 31159, 31160, 31161, 31162,
            31163, 31164, 31165, 31166, 31167, 31168, 31169, 31170, 31171,
            31172, 31173, 31174, 31175, 31176, 31177, 31178, 31179, 31180,
            31181, 31182, 31183, 31184, 31185, 31186, 31187, 31188, 31189,
            31190, 31191, 31192, 31193, 31194, 31195, 31196, 31197, 31198,
            31199, 31200, 31201, 31202, 31203, 31204, 31205, 31206, 31207,
            31208, 31209, 31210, 31211, 31212, 31213, 31214, 31215, 31216,
            31217, 31218, 31219, 31220, 31221, 31222, 31223, 31224, 31225,
            31226, 31227, 31228, 31229, 31230, 31231, 31232, 31233, 31234,
            31235, 31236, 31237, 31238, 31239, 31240, 31241, 31242, 31243,
            31244, 31245, 31246, 31247, 31248, 31249, 31250, 31251, 31252,
            31253, 31254, 31255, 31256, 31257, 31258, 31259, 31260, 31261,
            31262, 31263, 31264, 31265, 31266, 31267, 31268, 31269, 31270,
            31271, 31272, 31273, 31274, 31275, 31276, 31277, 31278, 31279,
            31280, 31281, 31282, 31283, 31284, 31285, 31286, 31287, 31288,
            31289, 31290, 31291, 31292, 31293, 31294, 31295, 31296, 31297,
            31298, 31299,
        ],
    },
    {
        id: 5,
        parent: '#',
        text: 'Gestiones Mutua',
        value: [31025, 31125],
    },
    {
        id: 6,
        parent: '#',
        text: 'Solicitudes',
        value: [
            36000, 36001, 36002, 36003, 36004, 36005, 36006, 36007, 36008,
            36009, 36010, 36011, 36012, 36013, 36014, 36015, 36016, 36017,
            36018, 36019, 36020, 36021, 36022, 36023, 36024, 36025, 36026,
            36027, 36028, 36029, 36030, 36031, 36032, 36033, 36034, 36035,
            36036, 36037, 36038, 36039, 36040, 36041, 36042, 36043, 36044,
            36045, 36046, 36047, 36048, 36049, 36050, 36051, 36052, 36053,
            36054, 36055, 36056, 36057, 36058, 36059, 36060, 36061, 36062,
            36063, 36064, 36065, 36066, 36067, 36068, 36069, 36070, 36071,
            36072, 36073, 36074, 36075, 36076, 36077, 36078, 36079, 36080,
            36081, 36082, 36083, 36084, 36085, 36086, 36087, 36088, 36089,
            36090, 36091, 36092, 36093, 36094, 36095, 36096, 36097, 36098,
            36099, 36100, 36101, 36102, 36103, 36104, 36105, 36106, 36107,
            36108, 36109, 36110, 36111, 36112, 36113, 36114, 36115, 36116,
            36117, 36118, 36119, 36120, 36121, 36122, 36123, 36124, 36125,
            36126, 36127, 36128, 36129, 36130, 36131, 36132, 36133, 36134,
            36135, 36136, 36137, 36138, 36139, 36140, 36141, 36142, 36143,
            36144, 36145, 36146, 36147, 36148, 36149, 36150, 36151, 36152,
            36153, 36154, 36155, 36156, 36157, 36158, 36159, 36160, 36161,
            36162, 36163, 36164, 36165, 36166, 36167, 36168, 36169, 36170,
            36171, 36172, 36173, 36174, 36175, 36176, 36177, 36178, 36179,
            36180, 36181, 36182, 36183, 36184, 36185, 36186, 36187, 36188,
            36189, 36190, 36191, 36192, 36193, 36194, 36195, 36196, 36197,
            36198, 36199, 36200, 36201, 36202, 36203, 36204, 36205, 36206,
            36207, 36208, 36209, 36210, 36211, 36212, 36213, 36214, 36215,
            36216, 36217, 36218, 36219, 36220, 36221, 36222, 36223, 36224,
            36225, 36226, 36227, 36228, 36229, 36230, 36231, 36232, 36233,
            36234, 36235, 36236, 36237, 36238, 36239, 36240, 36241, 36242,
            36243, 36244, 36245, 36246, 36247, 36248, 36249, 36250, 36251,
            36252, 36253, 36254, 36255, 36256, 36257, 36258, 36259, 36260,
            36261, 36262, 36263, 36264, 36265, 36266, 36267, 36268, 36269,
            36270, 36271, 36272, 36273, 36274, 36275, 36276, 36277, 36278,
            36279, 36280, 36281, 36282, 36283, 36284, 36285, 36286, 36287,
            36288, 36289, 36290, 36291, 36292, 36293, 36294, 36295, 36296,
            36297, 36298, 36299, 36300, 36301, 36302, 36303, 36304, 36305,
            36306, 36307, 36308, 36309, 36310, 36311, 36312, 36313, 36314,
            36315, 36316, 36317, 36318, 36319, 36320, 36321, 36322, 36323,
            36324, 36325, 36326, 36327, 36328, 36329, 36330, 36331, 36332,
            36333, 36334, 36335, 36336, 36337, 36338, 36339, 36340, 36341,
            36342, 36343, 36344, 36345, 36346, 36347, 36348, 36349, 36350,
            36351, 36352, 36353, 36354, 36355, 36356, 36357, 36358, 36359,
            36360, 36361, 36362, 36363, 36364, 36365, 36366, 36367, 36368,
            36369, 36370, 36371, 36372, 36373, 36374, 36375, 36376, 36377,
            36378, 36379, 36380, 36381, 36382, 36383, 36384, 36385, 36386,
            36387, 36388, 36389, 36390, 36391, 36392, 36393, 36394, 36395,
            36396, 36397, 36398, 36399, 36400, 36401, 36402, 36403, 36404,
            36405, 36406, 36407, 36408, 36409, 36410, 36411, 36412, 36413,
            36414, 36415, 36416, 36417, 36418, 36419, 36420, 36421, 36422,
            36423, 36424, 36425, 36426, 36427, 36428, 36429, 36430, 36431,
            36432, 36433, 36434, 36435, 36436, 36437, 36438, 36439, 36440,
            36441, 36442, 36443, 36444, 36445, 36446, 36447, 36448, 36449,
            36450, 36451, 36452, 36453, 36454, 36455, 36456, 36457, 36458,
            36459, 36460, 36461, 36462, 36463, 36464, 36465, 36466, 36467,
            36468, 36469, 36470, 36471, 36472, 36473, 36474, 36475, 36476,
            36477, 36478, 36479, 36480, 36481, 36482, 36483, 36484, 36485,
            36486, 36487, 36488, 36489, 36490, 36491, 36492, 36493, 36494,
            36495, 36496, 36497, 36498, 36499, 36500, 36501, 36502, 36503,
            36504, 36505, 36506, 36507, 36508, 36509, 36510, 36511, 36512,
            36513, 36514, 36515, 36516, 36517, 36518, 36519, 36520, 36521,
            36522, 36523, 36524, 36525, 36526, 36527, 36528, 36529, 36530,
            36531, 36532, 36533, 36534, 36535, 36536, 36537, 36538, 36539,
            36540, 36541, 36542, 36543, 36544, 36545, 36546, 36547, 36548,
            36549, 36550, 36551, 36552, 36553, 36554, 36555, 36556, 36557,
            36558, 36559, 36560, 36561, 36562, 36563, 36564, 36565, 36566,
            36567, 36568, 36569, 36570, 36571, 36572, 36573, 36574, 36575,
            36576, 36577, 36578, 36579, 36580, 36581, 36582, 36583, 36584,
            36585, 36586, 36587, 36588, 36589, 36590, 36591, 36592, 36593,
            36594, 36595, 36596, 36597, 36598, 36599, 36600, 36601, 36602,
            36603, 36604, 36605, 36606, 36607, 36608, 36609, 36610, 36611,
            36612, 36613, 36614, 36615, 36616, 36617, 36618, 36619, 36620,
            36621, 36622, 36623, 36624, 36625, 36626, 36627, 36628, 36629,
            36630, 36631, 36632, 36633, 36634, 36635, 36636, 36637, 36638,
            36639, 36640, 36641, 36642, 36643, 36644, 36645, 36646, 36647,
            36648, 36649, 36650, 36651, 36652, 36653, 36654, 36655, 36656,
            36657, 36658, 36659, 36660, 36661, 36662, 36663, 36664, 36665,
            36666, 36667, 36668, 36669, 36670, 36671, 36672, 36673, 36674,
            36675, 36676, 36677, 36678, 36679, 36680, 36681, 36682, 36683,
            36684, 36685, 36686, 36687, 36688, 36689, 36690, 36691, 36692,
            36693, 36694, 36695, 36696, 36697, 36698, 36699, 36700, 36701,
            36702, 36703, 36704, 36705, 36706, 36707, 36708, 36709, 36710,
            36711, 36712, 36713, 36714, 36715, 36716, 36717, 36718, 36719,
            36720, 36721, 36722, 36723, 36724, 36725, 36726, 36727, 36728,
            36729, 36730, 36731, 36732, 36733, 36734, 36735, 36736, 36737,
            36738, 36739, 36740, 36741, 36742, 36743, 36744, 36745, 36746,
            36747, 36748, 36749, 36750, 36751, 36752, 36753, 36754, 36755,
            36756, 36757, 36758, 36759, 36760, 36761, 36762, 36763, 36764,
            36765, 36766, 36767, 36768, 36769, 36770, 36771, 36772, 36773,
            36774, 36775, 36776, 36777, 36778, 36779, 36780, 36781, 36782,
            36783, 36784, 36785, 36786, 36787, 36788, 36789, 36790, 36791,
            36792, 36793, 36794, 36795, 36796, 36797, 36798, 36799, 36800,
            36801, 36802, 36803, 36804, 36805, 36806, 36807, 36808, 36809,
            36810, 36811, 36812, 36813, 36814, 36815, 36816, 36817, 36818,
            36819, 36820, 36821, 36822, 36823, 36824, 36825, 36826, 36827,
            36828, 36829, 36830, 36831, 36832, 36833, 36834, 36835, 36836,
            36837, 36838, 36839, 36840, 36841, 36842, 36843, 36844, 36845,
            36846, 36847, 36848, 36849, 36850, 36851, 36852, 36853, 36854,
            36855, 36856, 36857, 36858, 36859, 36860, 36861, 36862, 36863,
            36864, 36865, 36866, 36867, 36868, 36869, 36870, 36871, 36872,
            36873, 36874, 36875, 36876, 36877, 36878, 36879, 36880, 36881,
            36882, 36883, 36884, 36885, 36886, 36887, 36888, 36889, 36890,
            36891, 36892, 36893, 36894, 36895, 36896, 36897, 36898, 36899,
            36900, 36901, 36902, 36903, 36904, 36905, 36906, 36907, 36908,
            36909, 36910, 36911, 36912, 36913, 36914, 36915, 36916, 36917,
            36918, 36919, 36920, 36921, 36922, 36923, 36924, 36925, 36926,
            36927, 36928, 36929, 36930, 36931, 36932, 36933, 36934, 36935,
            36936, 36937, 36938, 36939, 36940, 36941, 36942, 36943, 36944,
            36945, 36946, 36947, 36948, 36949, 36950, 36951, 36952, 36953,
            36954, 36955, 36956, 36957, 36958, 36959, 36960, 36961, 36962,
            36963, 36964, 36965, 36966, 36967, 36968, 36969, 36970, 36971,
            36972, 36973, 36974, 36975, 36976, 36977, 36978, 36979, 36980,
            36981, 36982, 36983, 36984, 36985, 36986, 36987, 36988, 36989,
            36990, 36991, 36992, 36993, 36994, 36995, 36996, 36997, 36998,
            36999,
        ],
    },
    {
        id: 61,
        parent: '6',
        text: 'Empresa',
        value: [
            36001, 36002, 36003, 36004, 36005, 36006, 36007, 36008, 36009,
            36010, 36011, 36012, 36013, 36014, 36015, 36016, 36017, 36018,
            36019,
        ],
    },
    {
        id: 611,
        parent: '61',
        text: 'Citación Personal',
        value: [36001],
    },
    {
        id: 612,
        parent: '61',
        text: 'Pago por Talón',
        value: [36002],
    },
    {
        id: 613,
        parent: '61',
        text: 'Cambio de Puesto',
        value: [36003],
    },
    {
        id: 614,
        parent: '61',
        text: 'Suspensión de complementos',
        value: [36006],
    },
    {
        id: 615,
        parent: '61',
        text: 'Rescisión de contrato',
        value: [36004],
    },
    {
        id: 616,
        parent: '61',
        text: 'Prejubilación',
        value: [36005],
    },
    {
        id: 62,
        parent: '6',
        text: 'Inspección',
        value: [
            36010, 36011, 36012, 36013, 36014, 36015, 36016, 36017, 36018,
            36019,
        ],
    },
    {
        id: 621,
        parent: '62',
        text: 'Por alta',
        value: [36011],
    },
    {
        id: 622,
        parent: '62',
        text: 'Por incapacidad',
        value: [36012],
    },
    {
        id: 623,
        parent: '62',
        text: 'Por acumulación',
        value: [36013],
    },
    {
        id: 624,
        parent: '62',
        text: 'Por valoración',
        value: [36010],
    },
    {
        id: 63,
        parent: '6',
        text: 'Solicitudes médicas',
        value: [
            36020, 36021, 36022, 36023, 36024, 36025, 36026, 36027, 36028,
            36029,
        ],
    },
    {
        id: 631,
        parent: '63',
        text: 'Pruebas complementarias',
        value: [36010],
    },
    {
        id: 632,
        parent: '63',
        text: 'Adelanto de pruebas',
        value: [36022],
    },
    {
        id: 633,
        parent: '63',
        text: 'Especialista',
        value: [36023],
    },
    {
        id: 634,
        parent: '63',
        text: 'Rehabilitación',
        value: [36024],
    },
    {
        id: 635,
        parent: '63',
        text: 'Intervención quirúrgica',
        value: [36025],
    },
    {
        id: 636,
        parent: '63',
        text: 'Peritación',
        value: [36054],
    },
    {
        id: 7,
        parent: '#',
        text: 'Inspección',
        value: [36040, 36041, 36042, 36043],
    },
    {
        id: 637,
        parent: '4',
        text: 'Primer contacto',
        value: [31109],
    },
    {
        id: 638,
        parent: '4',
        text: 'Contactos telefónicos',
        value: [...numberGenerator(31101, 31102)],
    },
];

@Component({
    selector: 'app-task-type-tree-view',
    templateUrl: './task-type-tree-view.component.html',
    styleUrls: ['./task-type-tree-view.component.scss'],
    standalone: false
})
export class TaskTypeTreeViewComponent implements OnInit {
    public treeIcon = 'expand_more';
    public TaskList = TASK_TYPES;
    public isTreeInitialized: boolean;

    public TaskTypeTree: any;

    @Output() public TaskTypeSelect = new EventEmitter();
    @Output() public TaskTypeDeselect = new EventEmitter();

    @ViewChild(MatMenuTrigger) TaskTypeTreeMenu: MatMenuTrigger;

    constructor(
        private selectionService: SelectionGenericService,
        private filterService: FilterService
    ) {
        this.filterService.OnFiltersCleard.subscribe((res) => {
            this.initTaskTypeTree(true);
        });
    }

    ngOnInit(): void {
        // this.initAcivityTypeList();
        this.triggerTreeInit();
    }

    initAcivityTypeList(): void {
        this.TaskList = new Array<TreeView>();

        // FIRST NODE
        this.addToTaskTypeList(
            1,
            '#',
            'Gestiones administrativas',
            [10201, 10113, 10131, 13101]
        );
        this.addToTaskTypeList(11, '1', 'Solicitar fecha de alta', [10201]);
        this.addToTaskTypeList(12, '1', 'Confirmar datos', [10113]);
        this.addToTaskTypeList(13, '1', 'Pasar a baja', [10131]);
        this.addToTaskTypeList(14, '1', 'Contacto administrativo', [13101]);

        // SECOND NODE
        this.addToTaskTypeList(
            2,
            '#',
            'Citaciones',
            [13001, 13002, 13011, 14001, 14011]
        );
        this.addToTaskTypeList(21, '2', 'Burofax', [13001]);
        this.addToTaskTypeList(22, '2', 'Pedir cita (Burofax)', [13002]);
        this.addToTaskTypeList(23, '2', 'Acuse de recibo (Burofax)', [13011]);
        this.addToTaskTypeList(24, '2', 'SMS', [14001]);
        this.addToTaskTypeList(25, '2', 'Acuse de recibo (SMS)', [14011]);

        // THIRD NODE
        let types = this.getContinousNumberArray(30000, 30119);
        types = types.concat(this.getContinousNumberArray(30130, 30299));
        this.addToTaskTypeList(3, '#', 'Visitas', types);

        // FOUTH NODE
        types = this.getContinousNumberArray(31000, 31119);
        types = types.concat(this.getContinousNumberArray(31130, 31299));
        this.addToTaskTypeList(4, '#', 'Contactos:', types);

        // FIFTH NODE
        this.addToTaskTypeList(5, '#', 'Gestiones Mutua', [31025, 31125]);

        // SIXTH NODE
        types = this.getContinousNumberArray(36000, 36999);
        this.addToTaskTypeList(6, '#', 'Solicitudes', types);

        types = this.getContinousNumberArray(36001, 36019);
        this.addToTaskTypeList(61, '6', 'Empresa', types);

        this.addToTaskTypeList(611, '61', 'Citación Personal', [36001]);
        this.addToTaskTypeList(612, '61', 'Pago por Talón', [36002]);
        this.addToTaskTypeList(613, '61', 'Cambio de Puesto', [36003]);
        this.addToTaskTypeList(614, '61', 'Suspensión de complementos', [
            36006,
        ]);
        this.addToTaskTypeList(615, '61', 'Rescisión de contrato', [36004]);
        this.addToTaskTypeList(616, '61', 'Prejubilación', [36005]);

        types = this.getContinousNumberArray(36010, 36019);
        this.addToTaskTypeList(62, '6', 'Inspección', types);
        this.addToTaskTypeList(621, '62', 'Por alta', [36011]);
        this.addToTaskTypeList(622, '62', 'Por incapacidad', [36012]);
        this.addToTaskTypeList(623, '62', 'Por acumulación', [36013]);
        this.addToTaskTypeList(624, '62', 'Por valoración', [36010]);

        types = this.getContinousNumberArray(36020, 36029);
        this.addToTaskTypeList(63, '6', 'Mutua', types);
        this.addToTaskTypeList(631, '63', 'Pruebas complementarias', [36010]);
        this.addToTaskTypeList(632, '63', 'Adelanto de pruebas', [36022]);
        this.addToTaskTypeList(633, '63', 'Especialista', [36023]);
        this.addToTaskTypeList(634, '63', 'Rehabilitación', [36024]);
        this.addToTaskTypeList(635, '63', 'Intervención quirúrgica', [36025]);
        this.addToTaskTypeList(636, '63', 'Peritación', [36054]);

        // SEVENTH NODE
        types = this.getContinousNumberArray(36040, 36043);
        this.addToTaskTypeList(7, '#', 'Inspección', types);
    }

    triggerTreeInit(): void {
        if (!this.isTreeInitialized) {
            this.initTaskTypeTree();
        }
        this.treeIcon = 'expand_less';
        this.isTreeInitialized = true;
    }

    private addToTaskTypeList(
        Id: number,
        Parent: string,
        Text: string,
        Value: Array<number>
    ): void {
        this.TaskList.push({
            id: Id,
            parent: Parent,
            text: Text,
            value: Value,
        });
    }

    private getContinousNumberArray(start: number, end: number): Array<number> {
        const numberArray = new Array<number>();
        for (let i = start; i <= end; i++) {
            numberArray.push(i);
        }
        return numberArray;
    }

    initTaskTypeTree(isReset = false): void {
        this.TaskTypeTree = $('#task-type-tree').jstree({
            core: {
                data: this.TaskList,
                themes: { icons: false },
            },
            plugins: ['ui', 'checkbox'],
            search: {
                case_insensitive: true,
                show_only_matches: true,
            },
        });

        if (isReset) {
            this.TaskTypeTree.uncheck_all();
        } else {
            this.TaskTypeTree.on('loaded.jstree', (e: any, data: any) => {
                // SET SELECTED NODES ON TREE INIT
                this.selectionService.taskSelectionModal.TaskType.forEach(
                    (type) => {
                        this.TaskTypeTree.jstree().select_node(type.id);
                    }
                );

                this.TaskTypeTree.jstree('open_all');
            });

            this.TaskTypeTree.on('select_node.jstree', (e: any, data: any) => {
                this.TaskTypeSelect.emit(data.node);
            });

            this.TaskTypeTree.on(
                'deselect_node.jstree',
                (e: any, data: any) => {
                    this.TaskTypeDeselect.emit(data.node);
                }
            );
        }
    }
}
